import "./utility-tools.css";
import { initializeSpecialImageToPdf } from "./special-image-to-pdf.js";

initializeSpecialImageToPdf("heic");
